"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubstringNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'SUBSTRING';
class SubstringNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            var _a;
            const parseString = params.inputString || null;
            if (!parseString || params.startIndex % 1 !== 0 || params.endIndex % 1 !== 0) {
                return { output: undefined };
            }
            return {
                output: (_a = parseString.substring(params.startIndex < 0 ? params.inputString.length + params.startIndex : params.startIndex, params.endIndex < 0 ? params.inputString.length + params.endIndex : params.endIndex)) !== null && _a !== void 0 ? _a : undefined,
            };
        };
        this._interfaceDefinition = Schema;
    }
}
exports.SubstringNode = SubstringNode;
SubstringNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Substring',
    isIdempotent: true,
    primaryCategory: 'Text',
};
//# sourceMappingURL=Substring.js.map